// test2448
(2448 && 0);
